import { useState, useEffect } from "react";
import { useMap, Marker, Popup, Tooltip } from "react-leaflet";
import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

const MarkerLayer = ({ data }) => {
  const map = useMap();
  const [zoom, setZoom] = useState(map.getZoom());

  useEffect(() => {
    const handleZoom = () => setZoom(map.getZoom());
    map.on("zoomend", handleZoom);
    return () => map.off("zoomend", handleZoom);
  }, [map]);

  L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
  });

  const customIcon = ({ icon, zoom }) => {
    const height = 1.5;
    const showLogo = zoom >= 1;

    return L.divIcon({
      html: `
      <div class="my-marker">
          <div class="awesome-marker awesome-marker-icon-blue fa fa-info" style="font-size: 1rem; color: white;
           width: 35px;  height: 47px; line-height: 45px; text-align: center;">
        </div>
        ${
          showLogo
            ? `<div class="logo-icon">
                 <img src="${icon}" alt="" style="height: ${
                height + zoom / 8
              }rem" />
               </div>`
            : ""
        }
      </div>
    `,
      className: "",
      iconSize: [40, 40],
    });
  };

  return (
    <>
      {data.map((d, idx) => {
        const [lat, lng] = [
          parseFloat(d.latLong.split(",")[0]),
          parseFloat(d.latLong.split(",")[1]),
        ]; // or use item.lat, item.long
        if (!lat || !lng) return null; // Skip invalid positions
        return (
          <Marker
            key={idx}
            position={[lat, lng]}
            riseOffset={100}
            icon={customIcon({ icon: d.orgLogo, zoom })}
          >
            <Popup offset={[0, -20]}>
              <div className="map-popup">
                <div className="org-name"> {d.orgName}</div>{" "}
                <div className="desc"> {d.shortDescription}</div>
                <div className="email">
                  <a href={d.website} target="_blank" rel="noreferrer">
                    {d.website}
                  </a>
                </div>
              </div>
            </Popup>
            <Tooltip>{d.orgName}</Tooltip>
          </Marker>
        );
      })}
    </>
  );
};

export default MarkerLayer;
